// Voice accent preference: en-US (native English) or id-ID (Indonesian voice reading English)
// Stored in localStorage; used by all speakText functions across the app.

const KEY = "voice_accent_pref";

export const getVoiceLang = () => {
  try {
    const v = window.localStorage.getItem(KEY);
    return v === "id-ID" ? "id-ID" : "en-US";
  } catch {
    return "en-US";
  }
};

export const setVoiceLang = (lang) => {
  try {
    if (lang === "id-ID" || lang === "en-US") {
      window.localStorage.setItem(KEY, lang);
    }
  } catch {
    // ignore
  }
};

export const isIndonesianVoice = () => getVoiceLang() === "id-ID";
